import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from '@cbridge-utils/react-redux';
import { LoadingOverlay } from '@cbridge-tools/overlay';
import { FilterBlock, IFilterBlockState } from '@cbridge-tools/filters-panel';
import { ClearSymbolFilterButton } from './ClearFilterButton/ClearSymbolFilterButton';
import { CoreSymbolGroup } from './CoreSymbolGroup/CoreSymbolGroup';
import { coreSymbolGroupsFilterPropsSelector } from './CoreSymbolGroupsFilter.selector';

export const CoreSymbolGroupsFilter: FunctionComponent<IFilterBlockState> = (props) => {
  const { t } = useTranslation();

  const { symbolGroups, isLoading } = useSelector(coreSymbolGroupsFilterPropsSelector);

  if (isLoading) {
    return <LoadingOverlay />;
  }

  return (
    <FilterBlock
      label={t('text:configPage.coreSymbols.section.symbolGroups')}
      clearFilterAction={<ClearSymbolFilterButton />}
      items={symbolGroups}
      FilterBlockItemComponent={CoreSymbolGroup}
      {...props}
    />
  );
};
